import React from 'react';

import { useRouteMatchStrict } from 'hooks/useRouteMatchStrict';
import { RestorePasswordEmailForm } from 'containers/RestorePasswordEmailForm';
import { ServicePageLayoutComponent } from 'design/servicePageLayout';
import { TextComponent } from 'design/text/textComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { LinkControlComponent } from 'design/linkControl';
import { ORIGIN_SITE_URL } from 'utils/constants';
import { LogoComponent } from 'design/logo';
import { ContentLayoutComponent } from 'design/contentLayout';

type MatchParams = {
  token: string;
};

export const RestorePasswordPage = () => {
  const { restorePasswordPage: restorePasswordPageIntl } = useIntlDictionary();

  const {
    params: { token: emailToken = '' },
  } = useRouteMatchStrict<MatchParams>();

  const [emailAddress, setEmailAddress] = React.useState<string>('');

  const handleEmailFormSubmitSucceed = React.useCallback(
    (emailAddress: string) => {
      setEmailAddress(emailAddress);
    },
    []
  );

  const hasEmailForm = !emailToken && !emailAddress;

  const hasEmailCongrats = !emailToken && emailAddress;

  const bodyContentNode = React.useMemo(() => {
    if (hasEmailForm) {
      return (
        <RestorePasswordEmailForm
          onSubmitSucceed={handleEmailFormSubmitSucceed}
        />
      );
    }

    if (hasEmailCongrats) {
      return (
        <ContentLayoutComponent
          title={
            <TextComponent size="l" family="futura">
              {restorePasswordPageIntl.emailCongratsTitleText}
            </TextComponent>
          }
          body={
            <TextComponent>
              {restorePasswordPageIntl.emailCongratsDescriptionText(
                emailAddress
              )}
            </TextComponent>
          }
          backAction={null}
        />
      );
    }
  }, [
    emailAddress,
    handleEmailFormSubmitSucceed,
    hasEmailCongrats,
    hasEmailForm,
    restorePasswordPageIntl,
  ]);

  return (
    <ServicePageLayoutComponent
      sidebarContent={
        <LinkControlComponent to={ORIGIN_SITE_URL}>
          <TextComponent size="l">
            <LogoComponent />
          </TextComponent>
        </LinkControlComponent>
      }
      bodyContent={bodyContentNode}
    />
  );
};
